var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 154,
    transform: "translate(0.335938 0.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4556:50144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3342 126H29.3881C29.1294 126 29 125.742 29 125.613V97.7137C29 97.3262 29.3881 96.9387 29.7763 96.9387H57.3342C57.7224 96.9387 58.1105 97.3262 58.1105 97.7137V125.225C57.9811 125.612 57.7224 126 57.3342 126Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6445 96.9387H46.3373V105.463L43.4909 103.526L40.6445 105.463V96.9387Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.842 126H62.896C62.6372 126 62.5078 125.742 62.5078 125.613V97.7137C62.5078 97.3262 62.896 96.9387 63.2841 96.9387H90.842C91.2302 96.9387 91.6183 97.3262 91.6183 97.7137V125.225C91.4889 125.612 91.2302 126 90.842 126Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1523 96.9387H79.8451V105.463L76.9987 103.526L74.1523 105.463V96.9387Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.354 126H96.4077C96.1489 126 96.0195 125.742 96.0195 125.613V97.7137C96.0195 97.3262 96.4077 96.9387 96.7958 96.9387H124.354C124.742 96.9387 125.13 97.3262 125.13 97.7137V125.225C125.001 125.612 124.742 126 124.354 126Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.664 96.9387H113.357V105.463L110.51 103.526L107.664 105.463V96.9387Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3342 92.0307H29.3881C29.1294 92.0307 29 91.7724 29 91.6433V63.7444C29 63.357 29.3881 62.9695 29.7763 62.9695H57.3342C57.7224 62.9695 58.1105 63.357 58.1105 63.7444V91.2558C57.9811 91.6433 57.7224 92.0307 57.3342 92.0307Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6445 62.9695H46.3373V71.4941L43.4909 69.5567L40.6445 71.4941V62.9695Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.842 92.0307H62.896C62.6372 92.0307 62.5078 91.7724 62.5078 91.6433V63.7444C62.5078 63.357 62.896 62.9695 63.2841 62.9695H90.842C91.2302 62.9695 91.6183 63.357 91.6183 63.7444V91.2558C91.4889 91.6433 91.2302 92.0307 90.842 92.0307Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1523 62.9695H79.8451V71.4941L76.9987 69.5567L74.1523 71.4941V62.9695Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.354 92.0307H96.4077C96.1489 92.0307 96.0195 91.7724 96.0195 91.6433V63.7444C96.0195 63.357 96.4077 62.9695 96.7958 62.9695H124.354C124.742 62.9695 125.13 63.357 125.13 63.7444V91.2558C125.001 91.6433 124.742 92.0307 124.354 92.0307Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.664 62.9695H113.357V71.4941L110.51 69.5567L107.664 71.4941V62.9695Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3342 58.0613H29.3881C29.1294 58.0613 29 57.8029 29 57.6738V29.775C29 29.3875 29.3881 29 29.7763 29H57.3342C57.7224 29 58.1105 29.3875 58.1105 29.775V57.2863C57.9811 57.6738 57.7224 58.0613 57.3342 58.0613Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6445 29H46.3373V37.5246L43.4909 35.5872L40.6445 37.5246V29Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.842 58.0613H62.896C62.6372 58.0613 62.5078 57.8029 62.5078 57.6738V29.775C62.5078 29.3875 62.896 29 63.2841 29H90.842C91.2302 29 91.6183 29.3875 91.6183 29.775V57.2863C91.4889 57.6738 91.2302 58.0613 90.842 58.0613Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1523 29H79.8451V37.5246L76.9987 35.5872L74.1523 37.5246V29Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.354 58.0613H96.4077C96.1489 58.0613 96.0195 57.8029 96.0195 57.6738V29.775C96.0195 29.3875 96.4077 29 96.7958 29H124.354C124.742 29 125.13 29.3875 125.13 29.775V57.2863C125.001 57.6738 124.742 58.0613 124.354 58.0613Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.664 29H113.357V37.5246L110.51 35.5872L107.664 37.5246V29Z",
    fill: "#02475E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4556:50144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 97,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/Stock.eaf2329f5f40f0d7e1aa1d76f95866c9.svg";
export { ForwardRef as ReactComponent };